import secondaryComponents from "../..";
import { formatCurrency, truncateString } from "../../../../helpers";
import { v4 as uuidv4 } from "uuid";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const PricingTooltip = ({ name, pricings, store_currency }) => {
  return (
    <secondaryComponents.ToolTip
      placeholderContent={formatCurrency({
        value: pricings?.[0]?.unit_price,
        currencyCode: store_currency,
        decimal: 0,
      })}
      showInfoIcon={true}
      useContentStyling={true}
      contentStyles={{
        width: "100%",
        maxWidth: "300px",
        padding: "15px",
      }}
    >
      <h6 className="gray--text mb-3">{truncateString(name, 30)}</h6>

      <span
        className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pb-2`}
      >
        <p className="smallest-text-size">Pricing Types</p>
        <p className="smallest-text-size">Pricing</p>
      </span>
      {/* pricings */}
      <span>
        {pricings?.map((pricingItem) => (
          <div
            className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pt-2 pb-2`}
            key={uuidv4()}
          >
            <p className="smallest-text-size">
              {truncateString(pricingItem?.pricing_type?.label, 20)}
            </p>
            <p className="smallest-text-size">
              {formatCurrency({
                value: pricingItem?.unit_price,
                currencyCode: store_currency,
                decimal: 0,
              })}
            </p>
          </div>
        ))}
      </span>
    </secondaryComponents.ToolTip>
  );
};
